import _extends from '@babel/runtime/helpers/esm/extends';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import React from 'react';
import styled, { css, keyframes } from '@xstyled/styled-components';
import { Button } from '@trybeapp/ui.button';
import { XIcon } from '@heroicons/react/solid';

var _templateObject, _templateObject2;
var fade = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"])));
var StyledClearButton = /*#__PURE__*/styled(Button)(function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    pointer-events: auto;\n    animation: ", ";\n    animation-name: ", ";\n    width: 1.25rem;\n    height: 1.25rem;\n  "])), theme.transitions.medium, fade);
});
var ClearButton = function ClearButton(props) {
  return /*#__PURE__*/React.createElement(StyledClearButton, _extends({
    title: "Clear",
    variant: "ghost"
  }, props), /*#__PURE__*/React.createElement(XIcon, {
    className: "w-4 h-4 inline-block"
  }));
};

export { ClearButton, StyledClearButton };
